const KardApiErrors = Object.freeze({
  FETCH_REPORTS: 'There was a problem fetching the reports.',
});

export default KardApiErrors;
